import React from 'react';
import styled from 'styled-components';
import ContactBanner from '../Components/contactUs/ContactBanner';
import ContactDetails from '../Components/contactUs/ContantDetails';

const ContactUs = () => {
    // let map = ;
    return (
        <div>

            <ContactBanner />
            <Container>
                <FormContainer>
                    {/* <h4>Please fill in the form below and we will get back to you within 24 hours.</h4> */}
                    <h4>Write Us</h4>
                    <form>
                        <div className="form__element">
                            <input type="text" name="name" id="name" placeholder="Your Name" />
                        </div>
                        <div className="form__element">
                            <input type="text" name="email" id="email"
                                placeholder="Email or Phone number"
                            />
                        </div>
                        <div className="form__element">
                            <textarea name="message" id="message" cols="30" rows="10" placeholder="Message"></textarea>
                        </div>
                        <button>Submit</button>
                    </form>
                </FormContainer>
                <ContactDetails />
            </Container>
            <MapContainer className="map">

                <iframe src='https://maps.google.com/maps?q=mumbai%20maharashtra&t=&z=13&ie=UTF8&iwloc=&output=embed' loading="lazy"></iframe>
            </MapContainer>
        </div>
    )

}

export default ContactUs


const Container = styled.div`
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    /* justify-content: center; */
    /* background: #fff; */
    /* height: 65vh; */
    height: 100%;
    padding: 5rem 0rem;
    background: #fff;
    h1{
        margin: 1rem 0rem;
        color: white;
        font-size: 3rem;
    }
    @media screen and (max-width: 900px){
        flex-direction: column;
        h1{
            font-size: 2rem;
        }
    }
`;

const MapContainer = styled.div`
    width: 100%;
    height: 60vh;
    iframe{
        width: 100% !important;
        height: 100%;
    }
`

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    background: #fff;
    border-radius: 0.5rem;
    color: #1b1b1b;
    height: 60vh;
    width: 70%;
    padding: 2rem 2rem;
    h4{
        color: #000219;
        font-weight: 800;
        padding: 0.5rem 0rem; 
        font-size: 2rem;          
    }
    form{   
        display: flex;
        flex-direction: column;
        align-items: center;
        /* padding: 2rem 0rem; */
        width: 100%;
        height: 100%;
        .form__element{
            width: 100%;
        }
        input{
            appearance: none;
            outline: none;
            border: none;
            border: 1px solid #1b1b1b;
            width: 100%;
            padding: 0.8rem 0.4rem;
            border-radius: 0.3rem;
            margin-bottom: 1rem;
        }
        textarea{
            appearance: none;
            outline: none;
            resize: none;
            width: 100%;
            height: 5rem;
            border: none;
            border: 1px solid #1b1b1b;
            padding: 0.5rem 0.3rem;
            border-radius: 0.3rem;
        }
        button{
            cursor: pointer;
            width: 100%;
            padding: 0.6rem;
            font-size: 1.3rem;
            color: #fff;
            transition: 0.3s ease;
            margin: 1rem 1rem 0rem 1rem;
            /* border: 2px solid #23d997; */
            border: none;
            transition: all 0.5s ease;
            background: #E21F36;
            &:hover {
                background: orangered;
            }
            @media screen and (max-height: 900px) {
                padding: 0.6rem;
                font-size: 1.1rem;
            }
        }
    }
    @media screen and (max-width: 768px) {
        height: 50vh;
        width: 98vw;
        h4{
            /* font-size: 0.7rem; */
            padding: 0.2rem 0.3rem;
            text-align: center;
        }

    }
    `